'use client';

import { useCallback, useMemo } from 'react';
import { Category, type GameV1 } from '@/api/games';
import { TOP_GAME_PREVIEW_SUB_NAME } from '@/helpers/gameCategories';
import { useGamesList } from '@/hooks/useGamesList';
import { useGamesListLoader } from '@/hooks/useGamesListLoader';
import { useGetCommonStore } from '@/store/commonStore';

const NO_GAMES: GameV1[] = [];

export const useTopGamePreview = (enabled = true) => {
  const useCommonStore = useGetCommonStore();
  const getGamesByCategory = useCommonStore.use.getGamesByCategory();

  const topGamesState = useGamesList(
    'category',
    Category.TOP,
    TOP_GAME_PREVIEW_SUB_NAME
  );

  const loadTopGame = useCallback(() => {
    getGamesByCategory(Category.TOP, {
      pageSize: 1,
      staticAmount: true,
      subName: TOP_GAME_PREVIEW_SUB_NAME,
    });
  }, [getGamesByCategory]);

  useGamesListLoader(topGamesState, loadTopGame, enabled);

  const { list } = topGamesState;

  return useMemo(() => list?.games ?? NO_GAMES, [list]);
};
